import { SupportCategoryId, SupportCategoryResponse } from '@business/entities/SupportCategories';
import { TicketId } from '@business/entities/SupportTicket';
import { Endpoint } from '../endpoint';

export function fetchCategories() {
  return Endpoint.get<SupportCategoryResponse[]>(`@gc/support-category`);
}
export function ticketCategories(ticketId: TicketId) {
  return Endpoint.get<SupportCategoryResponse[]>(`@gc/support-category`, { params: { ticketId } });
}
export function fetchCategory(id: SupportCategoryId) {
  return Endpoint.get<SupportCategoryResponse>(`@gc/support-category/${id}`);
}
export function createCategory(data: Partial<SupportCategoryResponse>) {
  return Endpoint.post<SupportCategoryResponse>(`@gc/support-category`, { data: { ...data } });
}
export function updateCategory(id: SupportCategoryId, data: Partial<SupportCategoryResponse>) {
  return Endpoint.patch<SupportCategoryResponse>(`@gc/support-category/${id}`, { data: { ...data } });
}
export function deleteCategory(id: SupportCategoryId) {
  return Endpoint.delete<void>(`@gc/support-category/${id}`);
}
